<template>
  <div
    class="Landing-banner-container py-9 px-0"
    :style="{
      backgroundImage: $vuetify.breakpoint.mdAndUp ? `url('${require(`@/assets/landing-banner-1200.png`)}'` : ''
    }"
  >
    <div class="Landing-banner-wrapper">
      <div v-if="restrictedShop" class="Landing-banner-content" :class="{ fullWidth: !restrictedShop.logo }">
        <img
          v-if="restrictedShop.logo"
          width="120px"
          class="Landing-banner-logo"
          :src="`shop/logo/${restrictedShop.logo}`"
          :alt="$t('landing.logoAlt', { name: restrictedShop.displayName })"
        />
        <div class="Landing-banner-description">
          <h1>{{ restrictedShop.displayName }}</h1>
          <p>{{ restrictedShop.address1 }}</p>
          <p>{{ restrictedShop.address2 }}</p>
          <p>{{ restrictedShop.postalCode }} {{ restrictedShop.city }}</p>
          <span class="separator" />
          <p>{{ restrictedShop.phoneNumber }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

const GET_SHOP = key => gql`
  query restrictedShop($param: ${key === 'shopUuid' ? 'GUID' : 'ID'}) {
    restrictedShop(${key}: $param) {
      address1
      address2
      city
      country
      description
      displayName
      email
      enabled
      phoneNumber
      logo
      postalCode
      timezone
      shopUuid
    }
  }
`
export default {
  props: {
    eId: {
      type: String,
      required: false
    },
    shopUuid: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      restrictedShop: null
    }
  },
  apollo: {
    restrictedShop: {
      query() {
        return GET_SHOP(this && this.eId ? 'eId' : 'shopUuid')
      },
      variables() {
        return {
          param: this.eId || this.shopUuid
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.Landing-banner-container {
  background-color: white;
  background-position: center center;
  background-size: cover;
}

.Landing-banner-wrapper {
  max-width: 1600px;
  margin: auto;
}

.Landing-banner-content {
  display: grid;
  grid-gap: 50px;
  grid-template-columns: 120px 1fr;
  padding: 50px;
  max-width: 600px;
  background: #fff;

  &.fullWidth {
    display: inline-block;
    padding: 50px 120px;
  }

  h1 {
    font-size: 2.5em;
  }

  p {
    font-size: 1.1em;
    margin: 5px;
  }
}

.Landing-banner-logo {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.Landing-banner-description {
  max-width: 400px;
}
</style>
